import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { tokenInterceptor } from './interceptors/token.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';

import { provideToastr } from 'ngx-toastr';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideAnimationsAsync(),
    provideHttpClient(),
    provideAnimations(), // required animations providers
    provideToastr({
      //timeOut: 10000,
      positionClass: 'toast-bottom-right',
      disableTimeOut: false,
      preventDuplicates: true,
      newestOnTop: true,
    }), // Toastr providers
    provideHttpClient(withFetch(), withInterceptors([tokenInterceptor]))
  ]
};
